import { Link } from 'react-router-dom';
import { ArrowUpRight, Zap } from 'lucide-react';
import { SPORTS_HOME, SPORTS_LOGO, SPORTS_PALETTE } from '../data/sportsManagement';

// Homepage integration — announces SMG Sports Management as a first-class new division.
// Placement in App.js: between Praise and AwardsPress.
export default function SportsManagement() {
  return (
    <section
      id="sports-management"
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-36 overflow-hidden border-t border-white/5"
      data-testid="sports-management-home"
      style={{
        background: `linear-gradient(180deg, #000 0%, ${SPORTS_PALETTE.navy} 100%)`,
      }}
    >
      {/* Ambient court arc */}
      <div
        className="pointer-events-none absolute -right-40 -top-40 w-[70vw] h-[70vw] rounded-full blur-3xl opacity-30"
        style={{ background: `radial-gradient(closest-side, ${SPORTS_PALETTE.blue}, transparent 65%)` }}
      />
      <div
        className="pointer-events-none absolute -left-40 -bottom-40 w-[55vw] h-[55vw] rounded-full blur-3xl opacity-25"
        style={{ background: `radial-gradient(closest-side, ${SPORTS_PALETTE.green}, transparent 70%)` }}
      />

      <div className="relative grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        {/* Left: copy */}
        <div className="md:col-span-7">
          <div className="flex items-center gap-4 mb-6">
            <span className="w-10 h-px" style={{ background: SPORTS_PALETTE.blue }} />
            <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/85 flex items-center gap-2">
              <Zap className="w-3 h-3" style={{ color: SPORTS_PALETTE.orange }} />
              {SPORTS_HOME.eyebrow}
            </p>
          </div>
          <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tight mb-8 text-balance">
            {SPORTS_HOME.headline}
          </h2>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-2xl mb-12">
            {SPORTS_HOME.body}
          </p>

          {/* Dual CTAs */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to={SPORTS_HOME.primaryCta.to}
              className="group inline-flex items-center justify-center gap-3 text-white text-[11px] tracking-[0.3em] uppercase px-8 py-4 transition-all"
              style={{ background: SPORTS_PALETTE.blue }}
              onMouseEnter={(e) => (e.currentTarget.style.background = SPORTS_PALETTE.green)}
              onMouseLeave={(e) => (e.currentTarget.style.background = SPORTS_PALETTE.blue)}
              data-testid="sports-home-cta-primary"
            >
              {SPORTS_HOME.primaryCta.label}
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
            <Link
              to={SPORTS_HOME.secondaryCta.to}
              className="inline-flex items-center justify-center gap-3 border text-white text-[11px] tracking-[0.3em] uppercase px-8 py-4 transition-colors"
              style={{ borderColor: 'rgba(255,255,255,0.25)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#fff';
                e.currentTarget.style.color = SPORTS_PALETTE.navy;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#fff';
              }}
              data-testid="sports-home-cta-secondary"
            >
              {SPORTS_HOME.secondaryCta.label}
            </Link>
          </div>
        </div>

        {/* Right: logo lockup */}
        <div className="md:col-span-5 flex items-center justify-center md:justify-end">
          <div
            className="relative w-full max-w-md p-8 md:p-10 flex flex-col items-center bg-white/[0.03] border border-white/10 backdrop-blur-sm"
            data-testid="sports-home-logo-card"
          >
            <img
              src={SPORTS_LOGO}
              alt="SMG Sports Management Group International"
              draggable={false}
              className="w-full h-auto max-h-52 object-contain"
            />
            <div className="mt-6 pt-6 border-t border-white/10 w-full text-center">
              <p className="text-[10px] tracking-[0.35em] text-white/50">
                A DIVISION OF SMG MEDIA GROUP
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
